<template>
  <div>
    <ylFooterRecomMobile v-if="isMobileScreen" v-bind="$attrs" />
    <ylFooterRecomPC v-else v-bind="$attrs" />
  </div>
</template>
<script>
export default {
  name: "ylFooterRecom",
  components: {
    ylFooterRecomMobile: () => import("./components/mobile.vue"),
    ylFooterRecomPC: () => import("./components/pc.vue"),
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => { this.initScrollReveal() }, 1000);
    });
  },
  methods: {
    initScrollReveal() {
      this.$scrollReveal().reveal(".left-img", {
        duration: 1000, // 动画时长
        origin: "left", // 动画方向
        opacity: 1, // 初始透明度
        easing: "ease", // 动画缓动效果
        reset: false, // 是否在滚动回退时重新触发动画
        viewFactor: 0.1, // 元素进入视口的百分比
        rotate: {
          y: 90,
        }
      });
      this.$scrollReveal().reveal(".right-img", {
        duration: 1000, // 动画时长
        origin: "right", // 动画方向
        opacity: 1, // 初始透明度
        easing: "ease", // 动画缓动效果
        reset: false, // 是否在滚动回退时重新触发动画
        viewFactor: 0.1, // 元素进入视口的百分比
        rotate: {
          y: 90,
        }
      });
    },
  },
};
</script>